import { Grid, Text } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";

export default function PendingComponent() {
  const { t } = useTranslation("ui");
  return (
    <Grid align="center" justify="center" height="100vh" width="100%">
      <Text align="center">{t("loading")}</Text>
    </Grid>
  );
}
